import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { LogIn, ShieldAlert } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const [params] = useSearchParams();
  const err = params.get("error");

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A192F] text-white relative overflow-hidden font-body" data-testid="admin-login-page">
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: "linear-gradient(rgba(59,130,246,0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(59,130,246,0.2) 1px, transparent 1px)",
        backgroundSize: "60px 60px",
      }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#1E3A8A] rounded-full blur-3xl opacity-40" />

      <div className="relative max-w-md w-full mx-4 p-10 bg-white text-slate-900 rounded-2xl shadow-2xl">
        <Link to="/" className="font-heading font-bold text-2xl text-[#0A192F] tracking-tight">X10</Link>
        <div className="mt-1 text-xs uppercase tracking-[0.25em] text-slate-500 font-semibold">Admin Bereich</div>

        <h1 className="mt-8 font-heading font-bold text-3xl text-[#0A192F] leading-tight">Anmeldung</h1>
        <p className="mt-3 text-slate-600 leading-relaxed text-sm">
          Bitte melden Sie sich mit Ihrem autorisierten Google-Konto an, um auf den
          Verwaltungsbereich zuzugreifen.
        </p>

        {err && (
          <div className="mt-6 p-4 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm flex gap-3 items-start" data-testid="login-error">
            <ShieldAlert size={18} className="mt-0.5 flex-shrink-0" />
            <div>
              {err === "forbidden"
                ? "Dieses Konto ist nicht für den Admin-Bereich autorisiert."
                : "Anmeldung fehlgeschlagen. Bitte erneut versuchen."}
            </div>
          </div>
        )}

        <button
          onClick={handleLogin}
          data-testid="admin-login-google"
          className="mt-8 w-full inline-flex items-center justify-center gap-3 px-6 py-4 bg-[#0A192F] text-white font-semibold rounded-full hover:bg-[#1E3A8A] transition-colors"
        >
          <LogIn size={18} />
          Mit Google anmelden
        </button>

        <Link to="/" className="mt-6 block text-center text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 hover:text-[#0A192F]" data-testid="admin-login-back">
          Zurück zur Website
        </Link>
      </div>
    </div>
  );
}
